/**
 * Site-wide aurora background. Sits behind every page in a fixed layer.
 * Three Apple-style colour orbs drift on independent loops; gentle grain
 * overlay adds analogue depth. Pointer-events disabled so nothing intercepts clicks.
 */
export default function AuroraBackground() {
    return (
        <div
            aria-hidden
            className="pointer-events-none"
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 0,
                overflow: "hidden",
            }}
        >
            <div
                className="tk-aurora-orb tk-aurora-orb-1"
                style={{
                    top: "-15%",
                    left: "25%",
                    width: 720,
                    height: 720,
                    background:
                        "radial-gradient(circle, rgba(0,122,255,0.32), transparent 70%)",
                }}
            />
            <div
                className="tk-aurora-orb tk-aurora-orb-2"
                style={{
                    top: "35%",
                    right: "-10%",
                    width: 620,
                    height: 620,
                    background:
                        "radial-gradient(circle, rgba(52,199,89,0.22), transparent 70%)",
                }}
            />
            <div
                className="tk-aurora-orb tk-aurora-orb-3"
                style={{
                    top: "65%",
                    left: "-10%",
                    width: 620,
                    height: 620,
                    background:
                        "radial-gradient(circle, rgba(255,159,10,0.20), transparent 70%)",
                }}
            />
        </div>
    );
}
